import React from 'react';

/*
window.location.href = "https://www.marquet.cloud/pricing";
*/

const Footer = () => {

  return (
    <div className="footer--container">
      <div className="footer">
        <div className="footer-wrap">
          <div className="footer--logos">
            <div>
              <div>
                <img src={process.env.REACT_APP_URL_DOMAIN_NAME === `dev` ? `https://marquet-public-assets.s3.amazonaws.com/subscriptions-portal/Marquet_logo_white_SP.svg` : `https://prod-marquet-public-assets.s3.amazonaws.com/subscriptions-portal/Marquet_logo_white_SP.svg`} />
              </div>
            </div>
            <div>
              <div>
                <div>
                  <a href="https://www.linkedin.com/showcase/marquet-cloud/" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1536 1792" id="1537866154" data-icon-name="fa-linkedin">
                      <path fill="#ffffff" d="M349 625v991h-330v-991h330zM370 319q1 73-50.5 122t-135.5 49h-2q-82 0-132-49t-50-122q0-74 51.5-122.5t134.5-48.5 133 48.5 51 122.5zM1536 1048v568h-329v-530q0-105-40.5-164.5t-126.5-59.5q-63 0-105.5 34.5t-63.5 85.5q-11 30-11 81v553h-329q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5 114.5-15.5q171 0 275 113.5t104 332.5z"></path>
                    </svg>
                  </a>
                </div>
              </div>
              <div>
                <div>
                  <a href="https://www.facebook.com/MarquetCloud" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1792" id="1612998659" data-icon-name="fa-facebook-f">
                      <path fill="#ffffff" d="M959 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z"></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="footer--items">
            <div>
              <p>
                <span>Platform</span>
              </p>
            </div>
            <div>
              <p>
                <a href="https://www.marquet.cloud/solutions">Solutions</a>
              </p>
            </div>
            <div>
              <p>
                <a href="https://www.marquet.cloud/features">Features</a>
              </p>
            </div>
            <div>
              <p>
                <a href="https://www.marquet.cloud/integrations">Integrations</a>
              </p>
            </div>
          </div>
          <div className="footer--policies">
            <div className="logo">
              <div>
                <img src={process.env.REACT_APP_URL_DOMAIN_NAME === `dev` ? `https://marquet-public-assets.s3.amazonaws.com/subscriptions-portal/iFactum_logo_white_SP.svg` :`https://prod-marquet-public-assets.s3.amazonaws.com/subscriptions-portal/iFactum_logo_white_SP.svg`}/>
              </div>
            </div>
            <div className="widget">
              <div>
                <p>
                  <span>
                    Copyright 2023  iFactum®.  All rights reserved
                  </span>
                </p>
              </div>
            </div>
            <div className="widget">
              <div>
                <p>
                  <a href="https://www.ifactum.com/our-information-security-and-privacy-policies" target='blank'>Information Security and Privacy Policies</a>
                </p>
              </div>
            </div>
          </div>
          <div className="footer--resources">
            <div>
              <p>
                <span>Resources</span>
              </p>
            </div>
            <div>
              <p>
                <a href="https://www.marquet.cloud/blog">Blog</a>
              </p>
            </div>
            <div>
              <p>
                <a href="https://www.marquet.cloud/faqs">FAQ</a>
              </p>
            </div>
            <div className="widget--q">
              <div></div>
            </div>
            <div>
              <p>
                <span>
                  <a href="https://www.marquet.cloud/contact-us">
                    Contact Us
                  </a>
                  </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Footer;